import { isSameYear } from 'date-fns';

import { DateFormat } from './constants';
import { format } from './format';

function formatOrEmpty(date: Date | number | string, dateFormat: DateFormat): string {
  return format(date, dateFormat) ?? '';
}

/**
 * A start-to-end date range as a string, collapsing repeated month/year: a same-month range
 * ("May 26 – 27, 2026"), a same-year range ("May 26 – Jun 2, 2026"), or two full dates across a
 * year boundary. Pass `collapseSameDay` to render a single date when both fall on the same day.
 *
 * This is the string form of the `TimeRange` component in `@gonfalon/datetime`, which renders it.
 */
export function formatDateRange(
  start: Date | number | string,
  end: Date | number | string,
  { collapseSameDay = false }: { collapseSameDay?: boolean } = {},
): string {
  const startDay = formatOrEmpty(start, DateFormat.MMM_D_YYYY);
  const endDay = formatOrEmpty(end, DateFormat.MMM_D_YYYY);

  if (collapseSameDay && startDay === endDay) {
    return startDay;
  }
  if (formatOrEmpty(start, DateFormat.MMM_YYYY) === formatOrEmpty(end, DateFormat.MMM_YYYY)) {
    return `${formatOrEmpty(start, DateFormat.MMM_D)} – ${formatOrEmpty(end, DateFormat.D_YYYY)}`;
  }
  if (isSameYear(start, end)) {
    return `${formatOrEmpty(start, DateFormat.MMM_D)} – ${endDay}`;
  }
  return `${startDay} – ${endDay}`;
}
